/**
 * AETHELIS SHOPIFY PLUS THEME — MOTOR CRO & UX LUXURY (2025-2026)
 * Optimizaciones mobile-first inspiradas en Zen Studios
 */

document.addEventListener('DOMContentLoaded', () => {
  // 1. Offset dinámico según announcement bar
  initDynamicHeaderOffset();

  // 2. Selector de packs integrado en el Hero
  initPackSelector();

  // 3. Testimonio rotativo cada 5 segundos con fade suave
  initHeroReviewRotation();

  // 4. Sticky Bar móvil (visible solo al salir del Hero)
  initStickyBar();

  // 5. FAQ Accordion accesible
  initFAQ();

  // 6. Modal de Políticas Legales
  initPolicyModals();

  // Defer widgets no críticos para optimizar FCP y LCP
  const deferSecondary = () => {
    initLiveVisitors();
    initSocialProofTicker();
    initCountdown();
  };

  if ('requestIdleCallback' in window) {
    requestIdleCallback(deferSecondary, { timeout: 3000 });
  } else {
    setTimeout(deferSecondary, 2500);
  }
});

/* --------------------------------------------------------------------------
   1. OFFSET DINÁMICO DE HEADER SEGÚN ANNOUNCEMENT BAR
   -------------------------------------------------------------------------- */
function initDynamicHeaderOffset() {
  function updateHeaderTop() {
    requestAnimationFrame(() => {
      const bar = document.querySelector('.aethelis-announcement-bar');
      const header = document.querySelector('.ae-header');
      if (!bar) return;
      const h = bar.offsetHeight;
      if (header) {
        header.style.top = h + 'px';
      }
      document.documentElement.style.setProperty('--header-offset', h + 'px');
      document.documentElement.style.setProperty('--announce-height', h + 'px');
    });
  }

  updateHeaderTop();

  const annBar = document.querySelector('.aethelis-announcement-bar');
  if (annBar && typeof ResizeObserver !== 'undefined') {
    const ro = new ResizeObserver(updateHeaderTop);
    ro.observe(annBar);
  }

  window.addEventListener('resize', updateHeaderTop, { passive: true });

  const header = document.querySelector('.ae-header');
  if (header) {
    function checkHeader() {
      header.classList.toggle('scrolled', window.scrollY > 20);
    }
    window.addEventListener('scroll', checkHeader, { passive: true });
    checkHeader();
  }
}

/* --------------------------------------------------------------------------
   2. SELECTOR DE PACKS DEL HERO & TRAMITACIÓN DE COMPRA
   -------------------------------------------------------------------------- */
function initPackSelector() {
  const packs = document.querySelectorAll('.ae-pack');
  const heroPriceDisplay = document.getElementById('ae-cta-price') || document.getElementById('hero-price-display');
  const stickyPriceDisplay = document.getElementById('sticky-price-display');
  const qtyInput = document.getElementById('ae-qty') || document.getElementById('hero-qty');
  const variantInput = document.getElementById('ae-vid') || document.getElementById('hero-variant-id');
  const heroForm = document.getElementById('ae-hero-form') || document.getElementById('hero-buy-form');
  const stickyBtn = document.getElementById('sticky-cta-btn');

  if (!packs.length) return;

  function selectPack(pack) {
    packs.forEach(p => {
      p.classList.remove('active');
      p.setAttribute('aria-checked', 'false');
    });
    pack.classList.add('active');
    pack.setAttribute('aria-checked', 'true');

    const price = pack.getAttribute('data-price') || '49,99€';
    const qty = pack.getAttribute('data-qty') || '2';
    const variantId = pack.getAttribute('data-variant');

    if (qtyInput) qtyInput.value = qty;
    if (variantInput && variantId) variantInput.value = variantId;

    // Actualizar precio en botón hero con micro-animación
    if (heroPriceDisplay) {
      heroPriceDisplay.textContent = price;
      heroPriceDisplay.style.transform = 'scale(1.15)';
      heroPriceDisplay.style.transition = 'transform 0.15s ease';
      setTimeout(() => {
        heroPriceDisplay.style.transform = 'scale(1)';
      }, 150);
    }

    // Actualizar precio en sticky bar
    if (stickyPriceDisplay) {
      stickyPriceDisplay.textContent = price;
    }
  }

  packs.forEach(pack => {
    pack.addEventListener('click', () => selectPack(pack));
    pack.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        selectPack(pack);
      }
    });
  });

  // Tramitación directa a /cart/variant:qty o /checkout
  function handleCheckout(btnElem) {
    if (btnElem) {
      btnElem.disabled = true;
      btnElem.style.opacity = '0.85';
    }

    const qty = qtyInput ? (parseInt(qtyInput.value, 10) || 2) : 2;
    const rawVal = variantInput ? variantInput.value.trim() : '';

    if (rawVal && rawVal !== '1' && rawVal !== '0' && /^\d+$/.test(rawVal)) {
      window.location.href = `/cart/${rawVal}:${qty}`;
      return;
    }

    // Fallback dinámico buscando la variante en Shopify
    fetch('/products.json?limit=10')
      .then(r => r.json())
      .then(data => {
        if (data && data.products && data.products.length > 0) {
          let prod = data.products.find(item => {
            const h = (item.handle || '').toLowerCase();
            const t = (item.title || '').toLowerCase();
            return h.includes('alina') || t.includes('alina');
          }) || data.products[0];

          if (prod && prod.variants && prod.variants.length > 0) {
            const realVId = prod.variants[0].id;
            if (variantInput) variantInput.value = realVId;
            window.location.href = `/cart/${realVId}:${qty}`;
            return;
          }
        }
        window.location.href = '/checkout';
      })
      .catch(() => {
        window.location.href = '/checkout';
      });

    setTimeout(() => {
      window.location.href = '/checkout';
    }, 1200);
  }

  if (heroForm) {
    heroForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const ctaBtn = document.getElementById('ae-cta') || document.getElementById('hero-buy-btn');
      handleCheckout(ctaBtn);
    });
  }

  if (stickyBtn) {
    stickyBtn.addEventListener('click', (e) => {
      e.preventDefault();
      handleCheckout(stickyBtn);
    });
  }

  window.addEventListener('pageshow', () => {
    const ctaBtn = document.getElementById('ae-cta') || document.getElementById('hero-buy-btn');
    if (ctaBtn) {
      ctaBtn.disabled = false;
      ctaBtn.style.opacity = '1';
    }
    if (stickyBtn) {
      stickyBtn.disabled = false;
      stickyBtn.style.opacity = '1';
    }
  });
}

/* --------------------------------------------------------------------------
   3. TESTIMONIO ROTATIVO EN HERO (ROTACIÓN CADA 5 SEGUNDOS)
   -------------------------------------------------------------------------- */
function initHeroReviewRotation() {
  const reviews = [
    { 
      name: 'Carmen R.', loc: 'Madrid', 
      color: '#6C8164', initial: 'C',
      text: '"Llevaba meses con dolor de cuello y desde la primera noche dormí diferente. Increíble."'
    },
    { 
      name: 'Laura M.', loc: 'Barcelona', 
      color: '#C9A96E', initial: 'L',
      text: '"Pedimos el pack de 2 para mi pareja y para mí. Diferencia abismal. No dan calor y los ronquidos han bajado."'
    },
    { 
      name: 'María P.', loc: 'Sevilla', 
      color: '#D4849A', initial: 'M',
      text: '"Mi fisioterapeuta me la recomendó. Soporte perfecto durmiendo de lado o boca arriba."'
    },
    { 
      name: 'Roberto M.', loc: 'Valencia', 
      color: '#8B6F47', initial: 'R',
      text: '"9 horas en oficina y las cervicales me mataban. Tres semanas con la Alina y dejé el ibuprofeno."'
    },
    { 
      name: 'Ana G.', loc: 'Bilbao', 
      color: '#5B8A80', initial: 'A',
      text: '"Llegó en 24h perfectamente embalada. La calidad del memory foam se nota desde el primer momento."'
    },
    { 
      name: 'Sofía V.', loc: 'Málaga', 
      color: '#9B7EC8', initial: 'S',
      text: '"La compré con dudas y me ha sorprendido. Me despierto sin rigidez por primera vez en años."'
    },
    { 
      name: 'Diego L.', loc: 'Zaragoza', 
      color: '#C06B3A', initial: 'D',
      text: '"Compré el pack de 2. Mi mujer ya no quiere dormir sin ella. Las mejores compras son las que no esperas."'
    },
    { 
      name: 'Isabel F.', loc: 'Madrid', 
      color: '#6C8164', initial: 'I',
      text: '"El contra reembolso me dio confianza para probarla. Pagué al recibir y no me arrepiento nada."'
    },
    { 
      name: 'Javier T.', loc: 'Alicante', 
      color: '#4A7B9D', initial: 'J',
      text: '"Tengo cervicales crónicas. No cura el problema pero dormir bien hace que el día sea otro. Vale cada euro."'
    },
    { 
      name: 'Paula N.', loc: 'Valladolid', 
      color: '#A0522D', initial: 'P',
      text: '"Envío rápidísimo, embalaje perfecto y la almohada es exactamente lo que buscaba. Repetiría."'
    }
  ];

  const reviewEl = document.getElementById('ae-hero-review');
  if (!reviewEl) return;

  const avEl = document.getElementById('ae-rev-av');
  const nameEl = document.getElementById('ae-rev-name');
  const locEl = document.getElementById('ae-rev-loc');
  const textEl = document.getElementById('ae-rev-text');

  let idx = 0;

  function showReview(i) {
    const r = reviews[i % reviews.length];
    reviewEl.style.opacity = '0';
    reviewEl.style.transition = 'opacity 0.4s ease';
    
    setTimeout(() => {
      if (avEl) {
        avEl.textContent = r.initial;
        avEl.style.background = r.color;
      }
      if (nameEl) nameEl.textContent = r.name;
      if (locEl) locEl.textContent = '· ' + r.loc;
      if (textEl) textEl.textContent = r.text;
      reviewEl.style.opacity = '1';
    }, 400);
  }

  const rotationInterval = setInterval(() => {
    idx++;
    showReview(idx);
  }, 5000);

  window.addEventListener('beforeunload', () => {
    clearInterval(rotationInterval);
  });
}

/* --------------------------------------------------------------------------
   4. STICKY BAR MÓVIL (OCULTO EN HERO, VISIBLE AL SALIR)
   -------------------------------------------------------------------------- */
function initStickyBar() {
  const heroSection = document.querySelector('.ae-hero') || document.querySelector('.ae-hero-v2') || document.getElementById('hero');
  const stickyBar = document.getElementById('sticky-cta');

  if (!stickyBar || !heroSection) return;

  if (typeof IntersectionObserver !== 'undefined') {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          stickyBar.classList.remove('visible');
        } else {
          stickyBar.classList.add('visible');
        }
      });
    }, {
      root: null,
      threshold: 0.1
    });

    observer.observe(heroSection);
  } else {
    window.addEventListener('scroll', () => {
      const rect = heroSection.getBoundingClientRect();
      if (rect.bottom > 100) {
        stickyBar.classList.remove('visible');
      } else {
        stickyBar.classList.add('visible');
      }
    }, { passive: true });
  }
}

/* --------------------------------------------------------------------------
   5. FAQ ACCORDION ACCESIBLE
   -------------------------------------------------------------------------- */
function initFAQ() {
  const faqItems = document.querySelectorAll('.aethelis-faq-item');

  faqItems.forEach((item) => {
    const btn = item.querySelector('.aethelis-faq-btn');
    const collapse = item.querySelector('.aethelis-faq-collapse');

    if (!btn || !collapse) return;

    btn.addEventListener('click', () => {
      const isOpen = item.classList.contains('open');

      faqItems.forEach((other) => {
        if (other !== item) {
          other.classList.remove('open');
          const otherBtn = other.querySelector('.aethelis-faq-btn');
          const otherCol = other.querySelector('.aethelis-faq-collapse');
          if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
          if (otherCol) otherCol.style.maxHeight = null;
        }
      });

      if (isOpen) {
        item.classList.remove('open');
        btn.setAttribute('aria-expanded', 'false');
        collapse.style.maxHeight = null;
      } else {
        item.classList.add('open');
        btn.setAttribute('aria-expanded', 'true');
        collapse.style.maxHeight = collapse.scrollHeight + 'px';
      }
    });
  });
}

/* --------------------------------------------------------------------------
   6. LIVE VISITORS DINÁMICO
   -------------------------------------------------------------------------- */
function initLiveVisitors() {
  const els = document.querySelectorAll('.ae-live-count');
  if (!els.length) return;

  let n = Math.floor(Math.random() * (47 - 18 + 1)) + 18;
  els.forEach(el => el.textContent = n);

  setInterval(() => {
    n = Math.max(16, Math.min(52, n + Math.floor(Math.random() * 5) - 2));
    els.forEach(el => el.textContent = n);
  }, Math.random() * 6000 + 10000);
}

/* --------------------------------------------------------------------------
   7. SOCIAL PROOF TICKER (TOAST DE COMPRAS RECIENTES — ALINA EN SINGULAR)
   -------------------------------------------------------------------------- */
function initSocialProofTicker() {
  const msgs = [
    { n: 'Carmen', c: 'Madrid', t: 'acaba de pedir 2 Alina', m: 2, col: '#6C8164' },
    { n: 'Laura', c: 'Barcelona', t: 'ha pedido su Alina', m: 4, col: '#D4A373' },
    { n: 'María', c: 'Sevilla', t: 'acaba de pedir 2 Alina', m: 3, col: '#C27387' },
    { n: 'Roberto', c: 'Valencia', t: 'acaba de pedir 2 Alina', m: 5, col: '#8B6F47' },
    { n: 'Ana', c: 'Bilbao', t: 'ha pedido su Alina', m: 1, col: '#5B8A80' }
  ];

  const toast = document.createElement('div');
  toast.className = 'ae-toast';
  toast.setAttribute('role', 'status');
  toast.setAttribute('aria-live', 'polite');
  toast.innerHTML = `
    <div class="ae-toast-av" id="ae-av"></div>
    <div class="ae-toast-body">
      <div id="ae-toast-msg"></div>
      <div class="ae-toast-time" id="ae-toast-time"></div>
    </div>
    <button type="button" class="ae-toast-close" id="ae-toast-close" aria-label="Cerrar">✕</button>
  `;
  document.body.appendChild(toast);

  const closeBtn = document.getElementById('ae-toast-close');
  if (closeBtn) {
    closeBtn.addEventListener('click', () => {
      toast.classList.remove('ae-toast--show');
    });
  }

  let idx = 0;
  function showNext() {
    const m = msgs[idx % msgs.length];
    idx++;
    const av = document.getElementById('ae-av');
    const msg = document.getElementById('ae-toast-msg');
    const time = document.getElementById('ae-toast-time');
    if (!av || !msg || !time) return;

    av.textContent = m.n[0];
    av.style.background = m.col;
    msg.innerHTML = `<strong>${m.n} de ${m.c}</strong> ${m.t}`;
    time.textContent = `hace ${m.m} min`;
    toast.classList.add('ae-toast--show');

    setTimeout(() => {
      toast.classList.remove('ae-toast--show');
    }, 4500);
  }

  setTimeout(() => {
    showNext();
    setInterval(showNext, 12000);
  }, 8000);
}

/* --------------------------------------------------------------------------
   8. COUNTDOWN TIMER (47 MINUTOS CON PERSISTENCIA)
   -------------------------------------------------------------------------- */
function initCountdown() {
  const timerElem = document.getElementById('ae-countdown') || document.getElementById('hero-countdown');
  if (!timerElem) return;

  const STORAGE_KEY = 'aethelis_countdown_v2';
  const DURATION_SEC = 47 * 60;

  let targetTime = localStorage.getItem(STORAGE_KEY);
  const now = Date.now();

  if (!targetTime || parseInt(targetTime, 10) <= now) {
    targetTime = now + (DURATION_SEC * 1000);
    localStorage.setItem(STORAGE_KEY, targetTime);
  } else {
    targetTime = parseInt(targetTime, 10);
  }

  function updateTimer() {
    const current = Date.now();
    let remaining = Math.max(0, Math.floor((targetTime - current) / 1000));

    if (remaining <= 0) {
      targetTime = Date.now() + (DURATION_SEC * 1000);
      localStorage.setItem(STORAGE_KEY, targetTime);
      remaining = DURATION_SEC;
    }

    const minutes = Math.floor(remaining / 60);
    const seconds = remaining % 60;
    const formattedMin = minutes < 10 ? '0' + minutes : minutes;
    const formattedSec = seconds < 10 ? '0' + seconds : seconds;

    timerElem.textContent = `${formattedMin}:${formattedSec}`;
  }

  updateTimer();
  const timerInterval = setInterval(updateTimer, 1000);

  window.addEventListener('beforeunload', () => {
    clearInterval(timerInterval);
  });
}

/* --------------------------------------------------------------------------
   9. MODAL DE POLÍTICAS LEGALES
   -------------------------------------------------------------------------- */
function initPolicyModals() {
  const modal = document.getElementById('aethelis-policy-modal');
  const titleEl = document.getElementById('policy-modal-title');
  const bodyEl = document.getElementById('policy-modal-body');
  const closeBtn = document.getElementById('policy-modal-close-btn');
  const okBtn = document.getElementById('policy-modal-ok-btn');
  const policyBtns = document.querySelectorAll('[data-policy]');

  if (!modal || !titleEl || !bodyEl) return;

  const policies = {
    'aviso-legal': {
      title: 'Aviso Legal',
      html: `
        <h4>1. Datos Identificativos y Titularidad</h4>
        <p>En cumplimiento con el deber de información recogido en el artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y del Comercio Electrónico (LSSI-CE), se informa de que este sitio web es operado bajo la marca comercial <strong>Aethelis</strong>, especializada en descanso ergonómico cervical.</p>
        <p>Para cualquier consulta o soporte legal: <strong>soporte@aethelis.es</strong>.</p>
        <h4>2. Condiciones de Uso y Propiedad</h4>
        <p>Todos los derechos de propiedad industrial e intelectual de los textos, imágenes, esquemas de producto ("Almohada Cervical Alina") y marcas corresponden a Aethelis o sus legítimos licenciantes.</p>
      `
    },
    'privacidad': {
      title: 'Política de Privacidad y RGPD',
      html: `
        <h4>1. Responsable del Tratamiento</h4>
        <p>Aethelis trata los datos personales facilitados en estricto cumplimiento del RGPD (UE 2016/679) y la LOPDGDD 3/2018.</p>
        <h4>2. Finalidad</h4>
        <p>Gestionar y entregar los pedidos de la Almohada Alina en 24/48h, procesar pagos seguros o contra reembolso, y gestionar la garantía de 30 noches.</p>
        <p>Tus datos nunca se venden ni ceden a terceros. Puedes ejercer tus derechos en: <strong>soporte@aethelis.es</strong>.</p>
      `
    },
    'terminos': {
      title: 'Términos y Condiciones de Compra',
      html: `
        <h4>1. Precios y Envíos</h4>
        <p>Todos los precios mostrados incluyen IVA. El envío urgente 24/48h es 100% gratuito.</p>
        <h4>2. Formas de Pago</h4>
        <p><strong>Pago con Tarjeta:</strong> Pasarela cifrada SSL con autenticación 3D Secure (Visa, Mastercard, AMEX, Apple Pay, Google Pay).<br>
        <strong>Klarna:</strong> 3 cuotas sin intereses.<br>
        <strong>Contra Reembolso:</strong> Pagas en efectivo al mensajero al recibir el paquete en casa.</p>
        <h4>3. Garantía</h4>
        <p>Garantía de fabricación legal de 3 años y 30 noches de prueba sin riesgo.</p>
      `
    },
    'envios-devoluciones': {
      title: 'Política de Envíos y Devoluciones',
      html: `
        <h4>1. Entrega en 24/48 Horas</h4>
        <p>Los pedidos se procesan de inmediato y se entregan en 24-48 horas laborables por mensajería urgente con seguimiento por SMS.</p>
        <h4>2. Prueba de 30 Noches Sin Riesgo</h4>
        <p>Pruébala en tu propia cama durante 30 noches. Si no alivia tu tensión cervical, te devolvemos el 100% de tu dinero sin preguntas.</p>
        <p>Para gestionar cualquier devolución escribe a: <strong>soporte@aethelis.es</strong>.</p>
      `
    }
  };

  function openPolicy(key) {
    const data = policies[key];
    if (!data) return;
    titleEl.textContent = data.title;
    bodyEl.innerHTML = data.html;
    modal.classList.add('active');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    modal.classList.remove('active');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  policyBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const key = btn.getAttribute('data-policy');
      openPolicy(key);
    });
  });

  if (closeBtn) closeBtn.addEventListener('click', closeModal);
  if (okBtn) okBtn.addEventListener('click', closeModal);

  modal.addEventListener('click', (e) => {
    if (e.target === modal) closeModal();
  });

  window.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains('active')) {
      closeModal();
    }
  });
}
